export const words = {
  place: "Umístění",
  yes: "Ano",
  no: "Ne",
  new: "Nový",
  agb: 'AGB',
  agb_full: "Všeobecné podmínky",
  datenschutzerklaerung: "Zásady ochrany osobních údajů",
  status: "Stav",
  company_name: "Název společnosti",
  next_button: "Další",
  device_name: "Název zařízení",
  to_connect: "Připojení",
  pin: 'PIN',
  time: "Čas",
  first_name: "Křestní jméno",
  last_name: "Příjmení",
  code: "Kód",
  help: "Nápověda",
  total_time: "Celkový čas",
  latitude: "Zeměpisná šířka",
  longitude: "Zeměpisná délka",
  accuracy: "Přesnost",
  timestamp: "Časové razítko",
  device_id: "ID zařízení",
  active: "aktivní",
  o_clock: "Hodiny",
  loading: "Obchod",
  annotation: "Poznámka",
  since: "od",
  camera: "Fotoaparát",
  map: "Mapa",
  gallery: 'Galerie',
  work: "Práce",
  employees: "Zaměstnanci",
  login: "Registrace",
  login_action: "Přihlášení",
  calendar_week_abbreviation: 'KW',
  calendar: "Kalendář",
  to_call: "Volejte",
  email: "E-mail",
  attachment: "Příloha",
  operational_planning: "Operační plán",
  to_scan: "Skenování",
  download: "Stáhnout",
  export: "Export",
  to_document: "Dokument",
  checklist: "Kontrolní seznam",
  checklists: "Kontrolní seznamy",
  password: "Heslo",
  confirmation: "Potvrzení",
  confirm: "Potvrďte",
  confirmation_email: "Potvrzovací e-mail",
  unknown: "Neznámý",
  unknown_place: "Neznámé místo",
  unknown_plan: "Neoznačený rozvrh směn",
  project_no: "Projekt č.",
  project_file: "Soubor projektu",
  contact_person: "Kontakt",
  overtime: "Přesčasy",
  timesheet: "Jízdní řád",
  minustime: "Minus hodin",
  back: "Zpět",
  undo: "Zrušit",
  clockout: "Razítko",
  clocked_out: "s razítkem",
  clockin: "Razítko v",
  clocked_in: "s razítkem",
  dismiss: "Zrušit",
  discard: "Odmítat",
  finish: "Připraveno",
  or: "nebo",
  copy: "Kopírovat",
  qr_code: "QR kód",
  documentation: "Záznam času a dokumentace",
  attendance: "Terminál pro tablety",
  tiercontent: "Rozsah balení",
  start_now: "Začněte hned teď",
  skip: "přeskočit",
  logout_during_core_time: "Vyraženo během základní doby",
  absent_during_core_time: "Chybí během základního času",
  distance: "Vzdálenost",
  km_reading: "Počet ujetých kilometrů",
  the_start: 'Start',
  the_end: "Konec",
  license_plate: "Poznávací značka",
  details: "podrobnosti",
  hide: "skrýt",
  cost: "Náklady",
  file: "Soubor",
  address_book: "Adresář",
  template_plural: "Šablony",
  signature: "Podpis",
  main_project: "Hlavní projekt",
  main_projects: "Hlavní projekty",
  sub_projects: "Dílčí projekty",
  scan_to_login_header: "Registrace kódu QR",
  description: "Popis",
  project_location: "Umístění projektu",
  phone_number: "Telefonní číslo",
  project_info: "Informace o projektu",
  number_short: "Ne.",
  sketch: "Skica",
  video: 'Video',
  delete: "Odstranit",
  send: "Odeslat",
  sending: "Poslat...",
  save: "Uložit",
  granted: "schváleno",
  pending: "vyžádané",
  denied: "Odmítnuto",
  customer: "Zákazník",
  mobile_number: "Telefonní číslo",
  ok: 'Ok',
  day: "Den",
  tomorrow: "Ráno",
  days: "Dny | Den | Dny",
  holidays: "Dovolená",
  vacation_days: "Dovolená",
  vacation_hours: "Prázdninové hodiny",
  request: "Žádost",
  accept: "Přijmout",
  withdraw: "Stáhnout",
  hour_account: "Hodinový účet",
  period: "Období",
  to: "na",
  date: "Jmenování",
  number: "Číslo",
  message: "Zpráva",
  change: "změna",
  changed: "Změnil",
  changed_fields: "Změněná pole",
  type: 'Art',
  hour: "Hodina",
  hours: "Hodiny",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Hodiny",
  end: "konec",
  end_date: "Termín",
  start_date: "Datum zahájení",
  absence: "Nepřítomnost",
  month: "měsíc",
  week: "Týden",
  transcript: "Přepis",
  time_left: "zbývající",
  transcript_tasks: "Úkoly",
  add_task: "Nový",
  /** Differentiation in some languages (e.g. English) */
  from: "z",
  of: "z",
  of_hours: "od {hours} hodin",
  of_hours_abbreviation: "{hours} z hodin.",
  /**************/

  used: "použité",
  update: "Aktualizace",
  today: "dnes",
  correction: "Oprava",
  work_time: "Pracovní doba",
  break: "Přestávka",
  loading_time: "Doba načítání",
  driving_time: "Doba jízdy",
  business_trip: "Pracovní cesta",
  project: 'Projekt',
  special_one: "Speciální1",
  special_two: "Speciální2",
  clock: "Hodiny",
  search: "Vyhledávání",
  operation: "Aktivita",
  day_protocol: "Denní protokol",
  continue: "více",
  total_duration: "Celkový čas",
  duration: "Doba trvání",
  hello: "Dobrý den,",
  close: "zavřít",
  comment: "Komentář:",
  small: "malé",
  medium: "střední",
  large: "velké",
  sharpie: "Kolík",
  line: "Řádek",
  arrow: "Šipka",
  rectangle: "Obdélník",
  ellipse: "Elipsa",
  text: 'Text',
  language_settings: "Nastavení jazyka",
  clock_reminder: "Připomínka známky",
  individually: "Jedinec",
  from_o_clock: "z",
  to_o_clock: "na",
  eraser: "Guma",
  edit: "Upravit",
  legal_notes: "Právní",
  notes: "Poznámky",
  note: "Poznámka",
  imprint: "Otisk",
  open_source_licenses: "Licenční podmínky pro otevřený zdrojový kód",
  author: 'Autor',
  license_type: "Typ licence",
  version: "Verze",
  substitute: "Zastoupení",
  not_rated: "Nehodnoceno",
  weekly_working_hours: "Týdenní pracovní doba",
  show_less: "Zobrazit méně",
  office_center: "Kancelářské centrum",
  admin_view: "Správa NFC",
  register: "Registrace",
  shifts: {
    shift_attachments: "Přílohy (vrstva)",
    shift_plan_attachments: "Přílohy (směnný plán)",
    shift_plan: "Rozvrh směn",
    shift: "Vrstva"
  },
  absences: {
    sick: "Nemoc (pokračující výplata mzdy)",
    vacation: "Dovolená",
    workshop: "Seminář/kurz",
    special_vacation: "Zvláštní dovolená",
    school: "Škola",
    working_time_account: "Účet pracovní doby",
    holiday: "Dovolená",
    other: "Další",
    driving_time: "Doba jízdy",
    parental_leave: "Rodičovská dovolená",
    excused_absent: "Omluvená nepřítomnost (placená)",
    not_excused_absent: "Neomluvená nepřítomnost",
    sick_industrial_accident: "Nemoc Pracovní úraz (LFZ)",
    short_time_work: "Zkrácený pracovní úvazek (Kug)",
    maternity_pay: "Ochrana mateřství zákaz mzdy/zaměstnání",
    sick_child: "Péče o nemocné dítě s nemocenskou (denní) dávkou",
    sick_child_no_payment: "Péče o nemocné dítě bez nemocenské (denní) dávky",
    vacation_no_payment: "Neplacené volno",
    sick_before_short_time_work: "Nemocenské dávky/nemoc před Kugem",
    weather_related_failure: "Selhání v důsledku povětrnostních podmínek",
    sick_short_time_work: "Onemocnění během Kug",
    sick_no_payment: "Nemoc (bez pokračující výplaty mzdy)",
    company_vacation: "Firemní dovolená",
    meals_14_euro: "Malý příspěvek na stravování",
    meals_28_euro: "Velký příspěvek na stravování"
  },
  image_editor: {
    font_size: "Velikost písma",
    stroke_width: "Šířka čáry",
    stroke_color: "Barva čáry",
    text_color: "Barva písma",
    rotate_left: "Otočte se doleva",
    rotate_right: "Otočte se doprava",
    flip_horizontal: "Zrcadlo ve vodorovné poloze",
    flip_vertical: "Zrcadlo na výšku"
  },
  travel_log: {
    method_of_transportation: "Dopravní prostředky",
    company_car: "Služební vůz",
    private_car: "Osobní automobil",
    rental_car: "Pronájem vozu",
    taxi: 'Taxi',
    public_transportation: "Veřejná doprava",
    airplane: "Letadlo",
    train: "Železnice (dálková veřejná doprava)",
    other: "Další",
    km_reading_start: "Počátek kilometrů",
    km_reading_end: "Konec najetých kilometrů",
    net_expenses: "Cestovní výdaje (netto)",
    tax: "Daň z přidané hodnoty"
  },
  read_in: "Přečtěte si v",
  currency: "Měna",
  reason: "Důvod",
  label: "Označit",
  monday: "Pondělí",
  tuesday: "Úterý",
  wednesday: "Středa",
  thursday: "Čtvrtek",
  friday: "Pátek",
  saturday: "Sobota",
  sunday: "Neděle",
  break_alarm: "Rozbijte budík",
  clockin_reminder: "Připomínka k přihlášení",
  clockout_reminder: "Připomínka odhlášení odběru"
};